import { render, staticRenderFns } from "./DatePickerElement.vue?vue&type=template&id=a4e5e3bc&"
import script from "./DatePickerElement.vue?vue&type=script&lang=js&"
export * from "./DatePickerElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports